import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TimeUnit/Main";
import Form from "./TimeUnit/Form";

// Utils
import { getData, getAlert } from "../../../utils/SamuiUtils";

const TimeUnit = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState({
    TimeUnit_Id: 0,
    TimeUnit_Code: "",
    TimeUnit_Name: "",
    TimeUnit_Type: "CONTRACT",
    TimeUnit_Moment: "months",
    TimeUnit_Sort: "",
    TimeUnit_Status: "Y",
  });

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const res = await getData(
        "Tb_Set_TimeUnit",
        "1=1 ORDER BY TimeUnit_Type, TimeUnit_Sort, TimeUnit_Name"
      );
      const list = Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
      setDataMasterList(list);
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
    setFormData({
      TimeUnit_Id: 0,
      TimeUnit_Code: "",
      TimeUnit_Name: "",
      TimeUnit_Type: "CONTRACT",
      TimeUnit_Moment: "months",
      TimeUnit_Sort: "",
      TimeUnit_Status: "Y",
    });
    setSelectedData(null);
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      TimeUnit_Id: item.TimeUnit_Id,
      TimeUnit_Code: item.TimeUnit_Code ?? "",
      TimeUnit_Name: item.TimeUnit_Name || "",
      TimeUnit_Type: item.TimeUnit_Type || "CONTRACT",
      TimeUnit_Moment: item.TimeUnit_Moment || "",
      TimeUnit_Sort: item.TimeUnit_Sort ?? "",
      TimeUnit_Status: item.TimeUnit_Status || "Y",
    });
    setSelectedData(item);
  };

  return (
    <div className="TimeUnit">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              {mode === "S" ? (
                <Main
                  masterList={dataMasterList}
                  name={"หน่วยช่วงเวลา"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              ) : (
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"หน่วยช่วงเวลา"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeUnit;
